import styled from 'styled-components';
import colors from '@constants/Colors';
import { Spinner as SP } from 'components-core';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 288px;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
`;

export const Spinner = styled(SP)`
  margin-bottom: 56px;

  svg {
    width: 92px;
    height: 92px;
  }

  circle {
    stroke-width: 2;
  }
`;

export const Text = styled.h3`
  font-size: 20px;
  line-height: 26px;
  font-weight: 500;
  color: ${colors.darkSlate};
  max-width: 220px;
  margin: 0;
`;
